import React from "react";
import RDTable from "react-data-table-component";

// Same customStyles as ordrx_frontend/src/Components/DataTable/DataTable.js
const customStyles = {
	headRow: { style: { borderBottom: "1px solid #333", minHeight: "44px" } },
	headCells: { style: { fontSize: "12px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.03em", color: "#8a8f98" } },
	rows: {
		style: { minHeight: "52px", fontSize: "13.5px", color: "#333" },
		highlightOnHoverStyle: { backgroundColor: "#f3f4f6", borderBottomColor: "#e6e7ea", outline: "none" },
	},
	pagination: { style: { borderTop: "1px solid #e6e7ea", fontSize: "13px" } },
};

export default function DataTable(props) {
	return <RDTable customStyles={customStyles} pagination highlightOnHover pointerOnHover {...props} />;
}
